const Home = () => {
    return (
        <div className="container-fluid min-h-100">
            <div className="container-fluid card">
                Đang phát triển
            </div>
        </div>
    );
}
export default Home;